class ProductForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._eventAttached = false;
    setTimeout(() => {
      this.form = this.querySelector('form');
      this.idInput = this.form.elements['id'];
      this.submitButton = this.form.elements['add'];

      this.idInput.removeAttribute('disabled');

      this.notifyOnAdd = this.hasAttribute('notify-on-add');

      this._boundSubmit = this.submit.bind(this);

      this._eventAttached = true;
      this.form.addEventListener('submit', this._boundSubmit);
    });
  }

  disconnectedCallback() {
    clearTimeout(this._clearAddedTimer);

    if (this._eventAttached) {
      this._eventAttached = false;
      this.form.removeEventListener('submit', this._boundSubmit);
    }
  }

  async submit(e) {
    e.preventDefault();

    const data = new FormData(e.target);
    const item = Object.fromEntries(data.entries());

    const quickShop = this.closest('quick-shop');
    const opensDrawer = this.notifyOnAdd && !this.closest('.cart-draw');
    let drawerOpenedEarly = false;

    try {
      this.removeError();
      this._setIsAdding();

      // Open the drawer up front instead of after the round trip. Shopify
      // takes ~800ms to confirm the line item, and none of that is work
      // the shopper needs to wait on to see their cart - the drawer shows
      // a loading state and fills in when the real cart arrives.
      if (opensDrawer) {
        if (quickShop) await quickShop.hide();
        this._setDrawerAwaiting(true);
        theme.mfpOpen('cart');
        drawerOpenedEarly = true;
      }

      await window.theme.cart.store.getState().add(item);
      this._setDrawerAwaiting(false);
      // Not awaited: the "added" checkmark runs a 1.5s CSS animation, and
      // the cart is already updated by the time it starts. Waiting for it
      // delayed the drawer by that full 1.5s on every add to cart.
      this._setIsAdding(false);

      if (quickShop && !opensDrawer) {
        await quickShop.hide();
      }

      if (this.notifyOnAdd) {
        await window.theme.cart.store.getState().resetVariantsBeingAdded();
      } else {
        await window.theme.cart.store.getState().resetLatestAddedProduct();
        await window.theme.cart.store
          .getState()
          .resetVariantsBeingAdded(item.id);
      }
    } catch (e) {
      // The drawer may already be open over the form, which would hide the
      // error message. Close it so the shopper is looking at the button
      // they pressed when the reason appears next to it.
      this._setDrawerAwaiting(false);
      if (drawerOpenedEarly && window.jQuery && window.jQuery.magnificPopup) {
        window.jQuery.magnificPopup.close();
      }
      this._renderError(e.message);
      this._setIsAdding(false, true);
    }
  }

  _setDrawerAwaiting(awaiting) {
    const drawer = document.querySelector('.js-cart-draw');
    if (drawer) drawer.classList.toggle('cart-draw--awaiting', awaiting);
  }

  // Purely visual, and deliberately synchronous - callers must never wait
  // on it. It used to return a promise that only resolved on the
  // checkmark's animationend, which both delayed the cart drawer and made
  // the drawer's opening depend on an animation actually completing.
  _setIsAdding(isAdding = true, error = false) {
    if (!this.submitButton) return;

    if (error) {
      this.submitButton.classList.remove('is-adding');
      return;
    }

    if (isAdding) {
      this.submitButton.classList.remove('is-added');
      this.submitButton.classList.add('is-adding');
      return;
    }

    this.submitButton.classList.remove('is-adding');
    this.submitButton.classList.add('is-added');
    this._clearAddedState();
  }

  // Clears the checkmark once its animation finishes. The timer is a
  // fallback for when animationend never arrives - a backgrounded tab
  // freezes CSS animations, so without it the button could stay stuck
  // showing "added" indefinitely.
  _clearAddedState() {
    const button = this.submitButton;
    clearTimeout(this._clearAddedTimer);

    const clear = () => {
      clearTimeout(this._clearAddedTimer);
      button.removeEventListener('animationend', clear);
      button.classList.remove('is-added');
    };

    button.addEventListener('animationend', clear, { once: true });
    // Slightly longer than the 1.5s cart-added-tick animation.
    this._clearAddedTimer = setTimeout(clear, 1800);
  }

  _renderError(message) {
    this.removeError();

    if (this.submitButton) {
      const error = document.createElement('div');
      error.classList.add('errors', 'qty-error', 'u-small');
      error.innerHTML = message;
      this.submitButton.before(error);
    }
  }

  removeError() {
    const error = this.querySelector('.errors');
    if (!error) return;

    error.remove();
  }
}
customElements.define('product-form', ProductForm);
